import React, { useContext } from 'react';
import cn from 'classnames';
import ConfirmationButtons from './ConfirmationButtons';
import AttestationAgreementField from './AttestationAgreementField';
import Context from '../../Context';

const FooterContainer = () => {
  const {
    isAssign,
    submitBtnText,
    showAttestationFlag,
    hasSecureQns,
    isPracticeExam,
    canSubmit,
    onClose,
    toggleAttestationDialog,
    attestationAgreementChecked,
    attestationAgreementFieldName,
    submit,
    hasPracticeExamBehavior,
    isAdminOrCoordinator,
    openAssignments,
    individualStudentAssignmentFlag,
    manageMultipleClassesFlag,
    handleUpdateSingle,
    handleUpdateAll,
    showUpdateAllButton,
    isCompleted,
    footerSubmitBtnText,
    isUpdateAllEnabled: propIsUpdateAllEnabled,
    isSubmitting,
    canUpdateAll: propCanUpdateAll,
    isFullyMCQ,
    sendTelemetry,
  } = useContext(Context);
  // FY-20729 Remove this once we should use AttestationAgreement checkbox
  const hideAttestationAgreementOnPurpose = true;
  const onSubmit = (e) => {
    const onSubmit = isAssign ? submit : handleUpdateSingle;
    onSubmit(e);
    sendTelemetry();
  };
  const onUpdateAll = () => {
    const onUpdateAll = manageMultipleClassesFlag ? handleUpdateAll : null;
    onUpdateAll();
    sendTelemetry();
  };
  const canUpdateAll =
    showUpdateAllButton && !isCompleted ? propCanUpdateAll : null;
  const isUpdateAllEnabled =
    manageMultipleClassesFlag &&
    !isSubmitting &&
    (canSubmit || propIsUpdateAllEnabled);

  const handleAttestationFormLink = (e) => {
    e.stopPropagation();
    e.preventDefault();
    toggleAttestationDialog();
  };

  const amountOfClasses = (openAssignments && openAssignments.length) || 0;
  let additionalBtnText = `Apply to All Classes Assigned (${amountOfClasses})`;
  if (individualStudentAssignmentFlag) {
    additionalBtnText = `Apply to All Assignments (${amountOfClasses})`;
  }

  const showAttestationAgreement = hideAttestationAgreementOnPurpose
    ? false
    : isAssign &&
      showAttestationFlag &&
      !isFullyMCQ &&
      (hasSecureQns || (isPracticeExam && hasPracticeExamBehavior));

  return (
    <div
      className={cn(
        'flex items-center px-4.6 pt-4.2 pb-4.2',
        showAttestationAgreement ? 'justify-between' : 'justify-end',
      )}
    >
      {showAttestationAgreement && (
        <AttestationAgreementField
          name={attestationAgreementFieldName}
          value={attestationAgreementChecked}
          handleAttestationLink={handleAttestationFormLink}
        />
      )}
      <ConfirmationButtons
        className="form-controllers"
        onClose={onClose}
        onSubmit={onSubmit}
        closeBtnText="Cancel"
        submitBtnText={
          showUpdateAllButton ? footerSubmitBtnText : submitBtnText
        }
        additionalBtnText={canUpdateAll ? additionalBtnText : null}
        onAdditionalButtonClick={canUpdateAll ? onUpdateAll : null}
        canSubmit={canSubmit && !isAdminOrCoordinator && !isSubmitting}
        isAdditionalButtonEnabled={isUpdateAllEnabled}
        individualStudentAssignment={individualStudentAssignmentFlag}
      />
    </div>
  );
};

FooterContainer.displayName = 'FooterContainer';

export default FooterContainer;
